import React from 'react';
import PropTypes from 'prop-types';

import { Stack, Typography } from '@metarouter-private/mr-mui';
import { useQuerySampleEvents } from '@ion/api';

import SampleEventRow from './SampleEventRow';

export default function ListView({ onEdit, onDelete }) {
  const { data: sampleEvents, loading } = useQuerySampleEvents();

  if (loading) {
    return <Typography color="text.secondary">Loading...</Typography>;
  }

  if (sampleEvents.length === 0) {
    return <Typography color="text.secondary">No saved sample events</Typography>;
  }

  return (
    <Stack spacing={0}>
      {sampleEvents.map(sampleEvent => (
        <SampleEventRow key={sampleEvent.id} sampleEvent={sampleEvent} onEdit={onEdit} onDelete={onDelete} />
      ))}
    </Stack>
  );
}

ListView.propTypes = {
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};
